import Availability from '@/models/Workers/Availability';
import AvailabilityViewModel from '@/models/Workers/AvailabilityViewModel';
import ShiftDeclinedReason from '@/models/Shared/ShiftDeclinedReason';
import ShiftDeclinedReasonViewModel from '@/models/Shared/ShiftDeclinedReasonViewModel';
import Gender from '@/models/Shared/Gender'
import GenderViewModel from '@/models/Shared/GenderViewModel';
import WorkerStatus from '@/models/Workers/WorkerStatus';
import WorkerStatusViewModel from '@/models/Workers/WorkerStatusViewModel';
import TimesheetStatus from '@/models/Timesheets/TimesheetStatus';
import BookingStatus from '@/models/Bookings/BookingStatus';
import BookingStatusViewModel from '@/models/Bookings/BookingStatusViewModel';
import MaritalStatus from '@/models/Shared/MaritalStatus';
import MaritalStatusViewModel from '@/models/Shared/MartialStatusViewModel';
import NumberViewModel from '@/models/Shared/NumberViewModel';
import VehicleAccessType from '@/models/Shared/VehicleAccessType';
import VehicleAccessTypeViewModel from '@/models/Shared/VehicleAccessTypeViewModel';
import CancelledReasonViewModel from '@/models/Shared/CancelledReasonViewModel';
import CancelledReason from '@/models/Shared/CancelledReason';
import WorkType from '@/models/Shared/WorkType';
import FormTypeViewModel from '@/models/Forms/FormTypeViewModel';
import FormType from '@/models/Forms/FormType';
import QuestionTypeViewModel from '@/models/Questions/QuestionTypeViewModel';
import QuestionType from '@/models/Questions/QuestionType';
import AvailabilityRestrictionViewModel from '@/models/Workers/AvailabilityRestrictionViewModel';
import AvailabilityRestriction from '@/models/Workers/AvailabilityRestriction';
import JourneyType from '@/models/Timesheets/JourneyType';
import JourneyCalculationType from '@/models/Timesheets/JourneyCalculationType';
import JobStatusViewModel from '@/models/Jobs/JobStatusViewModel';
import JobStatus from '@/models/Jobs/JobStatus';
import PositionDto from '@/models/Positions/PositionDto';
import ContactStatusViewModel from '@/models/Contacts/ContactStatusViewModel';
import ContactStatus from '@/models/Contacts/ContactStatus';
import DistanceViewModel from '@/models/Shared/DistanceViewModel';
import JobType from '@/models/Jobs/JobType';
import NoteType from '@/models/Notes/NoteType';
import JobWorkerNotInterestedReason from '@/models/JobWorkers/JobWorkerNotInterestedReason';
import JobClosedReason from '@/models/Jobs/JobClosedReason';
import JobClosedReasonViewModel from '@/models/Jobs/JobClosedReasonViewModel';
import JobWorkerInterviewType from '@/models/JobWorkerInterviews/JobWorkerInterviewType';
import InPersonInterviewAddressType from '@/models/JobWorkerInterviews/InPersonInterviewAddressType';
import JobContactNotInterestedReason from '@/models/JobWorkers/JobContactNotInterestedReason';
import StringViewModel from '@/models/Shared/StringViewModel';
import CalendarTypes from '@/models/Shared/CalendarType';
import JobWorkerRejectedReason from '@/models/JobWorkers/JobWorkerRejectedReason';
import OfferCancelledReason from '@/models/JobWorkerOffers/OfferCancelledReason';
import InterviewCancelledReason from '@/models/JobWorkerInterviews/InterviewCancelledReason';
import JobWorkerInterviewWorkerDeclinedReason from '@/models/JobWorkerInterviews/JobWorkerInterviewWorkerDeclinedReason';
import JobWorkerInterviewContactDeclinedReason from '@/models/JobWorkerInterviews/JobWorkerInterviewContactDeclinedReason';
import JobWorkerOfferWorkerDeclinedReason from '@/models/JobWorkerOffers/JobWorkerOfferWorkerDeclinedReason';
import JobWorkerOfferContactDeclinedReason from '@/models/JobWorkerOffers/JobWorkerOfferContactDeclinedReason';
import SearchMatchType from '@/models/Shared/SearchMatchType';
import BookingRoleWorkerShiftRejectedReason from '@/models/BookingRoleWorkerShifts/BookingRoleWorkerShiftRejectedReason';
import LocationWorkerType from '@/models/LocationWorkers/LocationWorkerType';
import AgencyBrandThemeMode from '@/models/Agencies/AgencyBrandThemeMode';
import ConversationTopicType from '@/models/ConversationTopics/ConversationTopicType';
import EmailTemplateTypeViewModel from '@/models/EmailTemplates/EmailTemplateTypeViewModel';
import EmailTemplateType from '@/models/EmailTemplates/EmailTemplateType';
import IntegrationSystemIdConstants from '@/models/Integrations/IntegrationSystemIdConstants';
import CampaignStatusViewModel from '@/models/Campaigns/CampaignStatusViewModel';
import CampaignStatus from '@/models/Campaigns/CampaignStatus';
import SpecOutStatusViewModel from '@/models/SpecOuts/SpecOutStatusViewModel';
import SpecOutStatus from '@/models/SpecOuts/SpecOutStatus';
import ConversationStatusViewModel from '@/models/Conversations/ConversationStatusViewModel';
import ConversationStatus from '@/models/Conversations/ConversationStatus';
import InvoiceStatus from '@/models/Invoices/InvoiceStatus';
import KBVisibility from '@/models/KnowledgeBase/KBVisibility';
import KBContentType from '@/models/KnowledgeBase/KBContentType';
const countries = require('i18n-iso-countries')
countries.registerLocale(require('i18n-iso-countries/langs/en.json'))


export default class ListUtils {
    
    static brandThemeModes(): NumberViewModel[] {
        return [
            new NumberViewModel("Light", AgencyBrandThemeMode.Light),
            new NumberViewModel("Dark", AgencyBrandThemeMode.Dark),
        ]
    }

    static searchMatchTypes(): NumberViewModel[] {
        return [
            new NumberViewModel("All", SearchMatchType.All),
            new NumberViewModel("Any", SearchMatchType.Any),
        ]
    }
    
    static workerStatuses(): WorkerStatusViewModel[] {
        return [
            new WorkerStatusViewModel("Pending", WorkerStatus.Pending),
            new WorkerStatusViewModel("Review Required", WorkerStatus.ReviewRequired),
            new WorkerStatusViewModel("Active", WorkerStatus.Active),
            new WorkerStatusViewModel("Inactive", WorkerStatus.Inactive),
        ]
    }

    static conversationStatuses(): ConversationStatusViewModel[] {
        return [
            new ConversationStatusViewModel("Worker waiting", ConversationStatus.WorkerWaiting),
            new ConversationStatusViewModel("Agency waiting", ConversationStatus.AgencyUserWaiting),
            new ConversationStatusViewModel("No action required", ConversationStatus.NoActionRequired),
            new ConversationStatusViewModel("Archived", ConversationStatus.Archived),
        ]
    }

    static campaignStatuses(): CampaignStatusViewModel[] {
        return [
            new CampaignStatusViewModel("Draft", CampaignStatus.Draft),
            //new CampaignStatusViewModel("Scheduled", CampaignStatus.Scheduled),
            //new CampaignStatusViewModel("Processing", CampaignStatus.Processing),
            new CampaignStatusViewModel("Paused", CampaignStatus.Paused),
            new CampaignStatusViewModel("Active", CampaignStatus.Active),
            new CampaignStatusViewModel("Closed", CampaignStatus.Closed),
        ]
    }

    static specOutStatuses(): SpecOutStatusViewModel[] {
        return [
            new SpecOutStatusViewModel("Draft", SpecOutStatus.Draft),
            new SpecOutStatusViewModel("Sent", SpecOutStatus.Sent),
        ]
    }

    static contactStatuses(): ContactStatusViewModel[] {
        return [
            new ContactStatusViewModel("Active", ContactStatus.Active),
            new ContactStatusViewModel("Inactive", ContactStatus.Inactive),
        ]
    }

    static formTypes(): FormTypeViewModel[] {
        return [
            new FormTypeViewModel("Worker Terms & Conditions", FormType.WorkerTermsConditions),
            new FormTypeViewModel("Worker Right To Work", FormType.WorkerRightToWork),
            new FormTypeViewModel("Worker Qualification", FormType.WorkerQualification),
        ]
    }

    static emailTemplateTypes(): EmailTemplateTypeViewModel[] {
        return [
            //new EmailTemplateTypeViewModel(this.emailTemplateNameByType(EmailTemplateType.WorkerCampaign), EmailTemplateType.WorkerCampaign),
            //new EmailTemplateTypeViewModel(this.emailTemplateNameByType(EmailTemplateType.WorkerBookingOffer), EmailTemplateType.WorkerBookingOffer),
            //new EmailTemplateTypeViewModel(this.emailTemplateNameByType(EmailTemplateType.WorkerBookingRejection), EmailTemplateType.WorkerBookingRejection),
            //new EmailTemplateTypeViewModel(this.emailTemplateNameByType(EmailTemplateType.WorkerBookingConfirmation), EmailTemplateType.WorkerBookingConfirmation),
            //new EmailTemplateTypeViewModel(this.emailTemplateNameByType(EmailTemplateType.WorkerBookingCancellation), EmailTemplateType.WorkerBookingCancellation),
            //new EmailTemplateTypeViewModel(this.emailTemplateNameByType(EmailTemplateType.WorkerJobPermInviteSingle), EmailTemplateType.WorkerJobPermInviteSingle),
            //new EmailTemplateTypeViewModel(this.emailTemplateNameByType(EmailTemplateType.WorkerJobPermInviteMultiple), EmailTemplateType.WorkerJobPermInviteMultiple),
            //new EmailTemplateTypeViewModel(this.emailTemplateNameByType(EmailTemplateType.WorkerJobPermInterviewConfirmation), EmailTemplateType.WorkerJobPermInterviewConfirmation),
            //new EmailTemplateTypeViewModel(this.emailTemplateNameByType(EmailTemplateType.WorkerJobPermOfferAccepted), EmailTemplateType.WorkerJobPermOfferAccepted),
            new EmailTemplateTypeViewModel(this.emailTemplateNameByType(EmailTemplateType.ContactCampaign), EmailTemplateType.ContactCampaign),
            //new EmailTemplateTypeViewModel(this.emailTemplateNameByType(EmailTemplateType.ContactWorkerSendOut), EmailTemplateType.ContactWorkerSendOut),
            //new EmailTemplateTypeViewModel(this.emailTemplateNameByType(EmailTemplateType.ContactJobPermInterestedWorkers), EmailTemplateType.ContactJobPermInterestedWorkers),
            //new EmailTemplateTypeViewModel(this.emailTemplateNameByType(EmailTemplateType.ContactJobPermInterviewConfirmation), EmailTemplateType.ContactJobPermInterviewConfirmation),
            //new EmailTemplateTypeViewModel(this.emailTemplateNameByType(EmailTemplateType.ContactJobPermOfferConfirmation), EmailTemplateType.ContactJobPermOfferConfirmation)
        ]
    }

    static emailTemplateNameByType(value: EmailTemplateType) {
        switch (value) {
            case EmailTemplateType.WorkerCampaign:
                return "Worker Campaign";
            case EmailTemplateType.WorkerBookingOffer:
                return "Worker Booking Offer";
            case EmailTemplateType.WorkerBookingRejection:
                return "Worker Booking Rejection";
            case EmailTemplateType.WorkerBookingConfirmation:
                    return "Worker Booking Confirmation";
            case EmailTemplateType.WorkerBookingCancellation:
                return "Worker Booking Cancellation";
            case EmailTemplateType.WorkerJobPermInviteSingle:
                return "Worker Perm Job Invite Single";
            case EmailTemplateType.WorkerJobPermInviteMultiple:
                return "Worker Perm Job Invite Multiple";
            case EmailTemplateType.WorkerJobPermInterviewConfirmation:
                return "Worker Perm Job Interview Confirmation";
            case EmailTemplateType.WorkerJobPermOfferAccepted:
                return "Worker Perm Job Offer Accepted ";
            case EmailTemplateType.ContactCampaign:
                return "Contact Campaign";
            case EmailTemplateType.ContactWorkerSendOut:
                return "Contact Worker Send Out";
            case EmailTemplateType.ContactJobPermInterestedWorkers:
                return "Contact Perm Job Interested Workers";
            case EmailTemplateType.ContactJobPermInterviewConfirmation:
                return "Contact Perm Job Interview Confirmation";
            case EmailTemplateType.ContactJobPermOfferConfirmation:
                return "Contact Perm Job Offer Confirmation";
            default:
                return "Unknown";
        }
    }

    static integrationDescription(integrationSystemId: string) {

        switch (integrationSystemId) {
            case IntegrationSystemIdConstants.Xero:
                return 'Xero is a cloud-based accounting software platform for small and medium-sized businesses.';
            case IntegrationSystemIdConstants.SendGrid:
                return 'SendGrid is a cloud-based email delivery service that provides reliable and scalable email communication.';
            case IntegrationSystemIdConstants.Microsoft365:
                return 'Microsoft 365 integration enables Single Sign-On with Microsoft accounts and mailbox synchronization for tracking email communications.';
            case IntegrationSystemIdConstants.GoogleWorkspace:
                return 'Google Workspace integration enables Single Sign-On with Google accounts and mailbox synchronization for tracking email communications.';
            case IntegrationSystemIdConstants.PurePro:
                return 'PurePro is a UK payroll bureau platform. Push workers, customers and approved timesheets each week and pull back payslips and holiday accruals.';
            default:
                return 'Integration description not available.';
        }
    }

     static integrationGiganautFeatures(integrationSystemId: string) {
        switch (integrationSystemId) {
            case IntegrationSystemIdConstants.Xero:
                return [
                    'Link Giganaut companies to Xero contacts',
                    'Create invoices from Timesheets in Giganaut and send them to Xero.',
                    'Navigate to a your Xero invoices from within Giganaut.',
                    'Navigate back Giganaut invoices from within Xero.'
                ];
            case IntegrationSystemIdConstants.SendGrid:
                return [
                    'Send Giganaut shift, perm job and campaign related emails from your SendGrid account.',
                    'Use your own SendGrid dynamic templates and Giganaut merge fields.',
                ];
            case IntegrationSystemIdConstants.Microsoft365:
                return [
                    'Allow users to sign in with their Microsoft account (Single Sign-On).',
                    'Users can connect their Outlook mailbox to sync email communications.',
                    'Track inbound and outbound emails on contact, worker, and company timelines.',
                    'Automatic email matching to existing records.'
                ];
            case IntegrationSystemIdConstants.GoogleWorkspace:
                return [
                    'Allow users to sign in with their Google account (Single Sign-On).',
                    'Users can connect their Gmail mailbox to sync email communications.',
                    'Track inbound and outbound emails on contact, worker, and company timelines.',
                    'Automatic email matching to existing records.'
                ];
            case IntegrationSystemIdConstants.PurePro:
                return [
                    'Push Giganaut workers to PurePro as part of the weekly payroll run.',
                    'Submit approved timesheets to PurePro (with both pay rate and bill rate per line).',
                    'Background poll of PurePro to detect when each pay run has been processed.',
                    'Pull payslips and holiday accrual balances back into Giganaut.',
                ];
            default:
                return 'No specific Giganaut features available for this integration.';
        }
     }

    static locationWorkerTypes(): NumberViewModel[] {
        return [
            new NumberViewModel("Favourite", LocationWorkerType.Favourite),
            new NumberViewModel("Blocked", LocationWorkerType.Blocked),
        ]
    }

    static noteTypes(): NumberViewModel[] {
        return [
            new NumberViewModel("General", NoteType.General),
            new NumberViewModel("Call", NoteType.Call),
            new NumberViewModel("Meeting", NoteType.Meeting),
        ]
    }

    static distanceOptions(): DistanceViewModel[] {
        return [
            new DistanceViewModel(1, "1"),
            new DistanceViewModel(2, "2"),
            new DistanceViewModel(3, "3"),
            new DistanceViewModel(4, "4"),
            new DistanceViewModel(5, "5"),
            new DistanceViewModel(6, "6"),
            new DistanceViewModel(7, "7"),
            new DistanceViewModel(8, "8"),
            new DistanceViewModel(9, "9"),
            new DistanceViewModel(10, "10"),
            new DistanceViewModel(15, "15"),
            new DistanceViewModel(20, "20"),
            new DistanceViewModel(25, "25"),
            new DistanceViewModel(30, "30"),
            new DistanceViewModel(35, "35"),
            new DistanceViewModel(40, "40"),
            new DistanceViewModel(45, "45"),
            new DistanceViewModel(50, "50"),
            new DistanceViewModel(0, "Unlimited"),
        ]
    }

    static questionTypes(): QuestionTypeViewModel[] {
        return [
            new QuestionTypeViewModel("Yes/No", QuestionType.YesNo),
            new QuestionTypeViewModel("Legal", QuestionType.Legal),
            new QuestionTypeViewModel("Integer", QuestionType.Integer),
            new QuestionTypeViewModel("Decimal", QuestionType.Decimal),
            new QuestionTypeViewModel("Date", QuestionType.Date),
            new QuestionTypeViewModel("Text", QuestionType.Text),
            new QuestionTypeViewModel("Text Area", QuestionType.TextArea),
            new QuestionTypeViewModel("Multiple Choice", QuestionType.MultipleChoice),
            new QuestionTypeViewModel("Drop Down", QuestionType.DropDown),
            new QuestionTypeViewModel("File Upload", QuestionType.FileUpload),
        ]
    }

    static conversationTopicTypes(): NumberViewModel[] {
        return [
            new NumberViewModel("Central", ConversationTopicType.Central),
            new NumberViewModel("Branch", ConversationTopicType.Branch),
            new NumberViewModel("Desk", ConversationTopicType.Desk),
        ]
    }

    static contentVisibilityOptions(): NumberViewModel[] {
        return [
            new NumberViewModel("Internal", KBVisibility.Internal),
            new NumberViewModel("External", KBVisibility.External),
        ]
    }

    static contentTypeOptions(): NumberViewModel[] {
        return [
            new NumberViewModel("Page", KBContentType.Page),
            new NumberViewModel("Table of Contents", KBContentType.TOC),
        ]
    }

    static bookingStatuses(): BookingStatusViewModel[] {
        return [
            new BookingStatusViewModel("Active", BookingStatus.Active),
            new BookingStatusViewModel("Cancelled", BookingStatus.Cancelled),
        ]
    }

    static jobStatuses(): JobStatusViewModel[] {
        return [
            new JobStatusViewModel("Open", JobStatus.Open),
            new JobStatusViewModel("Closed", JobStatus.Closed),
        ]
    }

    static jobClosedReasonOptions(): JobClosedReasonViewModel[] {
        return [
            new JobClosedReasonViewModel("Created by mistake", JobClosedReason.CreatedByMistake),
            new JobClosedReasonViewModel("Requirements changed", JobClosedReason.RequirementsChanged),
            new JobClosedReasonViewModel("Lost", JobClosedReason.Lost),
            new JobClosedReasonViewModel("Partially placed", JobClosedReason.PartiallyPlaced),
            new JobClosedReasonViewModel("Fully placed", JobClosedReason.FullyPlaced),
        ]
    }

    static genders(): GenderViewModel[] {
        return [
            new GenderViewModel("Male", Gender.Male),
            new GenderViewModel("Female", Gender.Female),
            new GenderViewModel("Non-binary", Gender.NonBinary),
            new GenderViewModel("Transgender", Gender.Transgender),
            new GenderViewModel("Intersex", Gender.Intersex),
            new GenderViewModel("Prefer not to say", Gender.PreferNotToSay),
            new GenderViewModel("Unknown", Gender.Unknown),
        ]
    }

    static maritalStatuses(): MaritalStatusViewModel[] {
        return [
            new MaritalStatusViewModel("Single", MaritalStatus.Single),
            new MaritalStatusViewModel("Married", MaritalStatus.Married),
            new MaritalStatusViewModel("Unknown", MaritalStatus.Unknown),
        ]
    }

    // Payroll-send enums — mirror the TITLE_* / PAYMENT_METHOD_* / UK_*
    // constants in api/core/workers.go. Used by the Worker → Payroll Details
    // edit dialog. Display strings here are what the user sees; int values
    // are what the backend persists.
    static titles(): NumberViewModel[] {
        return [
            new NumberViewModel("Unknown", 0),
            new NumberViewModel("Mr", 1),
            new NumberViewModel("Mrs", 2),
            new NumberViewModel("Ms", 3),
            new NumberViewModel("Miss", 4),
            new NumberViewModel("Mx", 5),
            new NumberViewModel("Dr", 6),
            new NumberViewModel("Prof", 7),
            new NumberViewModel("Rev", 8),
        ]
    }

    static paymentMethods(): NumberViewModel[] {
        return [
            new NumberViewModel("Unknown", 0),
            new NumberViewModel("BACS", 1),
            new NumberViewModel("Cash", 2),
            new NumberViewModel("Cheque", 3),
        ]
    }

    static ukTaxCodeBases(): NumberViewModel[] {
        return [
            new NumberViewModel("Unknown", 0),
            new NumberViewModel("Cumulative", 1),
            new NumberViewModel("Week 1 / Month 1", 2),
        ]
    }

    static ukNiCategories(): NumberViewModel[] {
        return [
            new NumberViewModel("Unknown", 0),
            new NumberViewModel("A — Standard adult employee", 1),
            new NumberViewModel("B — Married women / widows (reduced rate)", 2),
            new NumberViewModel("C — Above State Pension age", 3),
            new NumberViewModel("F — Freeport, standard category", 4),
            new NumberViewModel("H — Apprentice under 25", 5),
            new NumberViewModel("I — Freeport, married women / widows (reduced rate)", 6),
            new NumberViewModel("J — Deferred (already paying through another job)", 7),
            new NumberViewModel("L — Freeport, deferred", 8),
            new NumberViewModel("M — Under 21", 9),
            new NumberViewModel("S — Freeport, State Pension age", 10),
            new NumberViewModel("V — Veterans, first 12 months", 11),
            new NumberViewModel("X — No NICs payable", 12),
            new NumberViewModel("Z — Under 21, deferred", 13),
        ]
    }

    static ukStarterDeclarations(): NumberViewModel[] {
        return [
            new NumberViewModel("Unknown", 0),
            new NumberViewModel("Statement A — first job since 6 April", 1),
            new NumberViewModel("Statement B — only job, but had others since 6 April", 2),
            new NumberViewModel("Statement C — has another job or pension", 3),
        ]
    }

    static ukStudentLoanPlans(): NumberViewModel[] {
        return [
            new NumberViewModel("None", 0),
            new NumberViewModel("Plan 1", 1),
            new NumberViewModel("Plan 2", 2),
            new NumberViewModel("Plan 4", 3),
            new NumberViewModel("Plan 5", 4),
            new NumberViewModel("Postgraduate", 5),
        ]
    }

    static availabilityRestrictions(): AvailabilityRestrictionViewModel[] {
        return [
            new AvailabilityRestrictionViewModel("None", AvailabilityRestriction.None),
            new AvailabilityRestrictionViewModel("48 Hour Working Time Directive", AvailabilityRestriction.Uk48HourDirective),
            new AvailabilityRestrictionViewModel("20 Hour Student Visa", AvailabilityRestriction.Uk20HourStudentVisa),

        ]
    }

    static shiftDeclinedReasons(): ShiftDeclinedReasonViewModel[] {
        return [
            new ShiftDeclinedReasonViewModel("Too short notice", ShiftDeclinedReason.BOOKING_DECLINED_REASON_TOO_SHORT_NOTICE),
            new ShiftDeclinedReasonViewModel("Unavailable", ShiftDeclinedReason.BOOKING_DECLINED_REASON_UNAVAILABLE),
            new ShiftDeclinedReasonViewModel("Working elsewhere", ShiftDeclinedReason.BOOKING_DECLINED_REASON_WORKING_ELSEWHERE),
            new ShiftDeclinedReasonViewModel("Pay rate too low", ShiftDeclinedReason.BOOKING_DECLINED_REASON_PAY_RATE),
            new ShiftDeclinedReasonViewModel("Transport problem", ShiftDeclinedReason.BOOKING_DECLINED_REASON_TRANSPORT),
            new ShiftDeclinedReasonViewModel("Not interested in this position", ShiftDeclinedReason.BOOKING_DECLINED_REASON_POSITION),
        ]
    }

    static jobWorkerNotInterestedReasons(): NumberViewModel[] {
        return [
            new NumberViewModel("I'm not looking for a job currently", JobWorkerNotInterestedReason.NotLooking),
            new NumberViewModel("I'm not interested in this position", JobWorkerNotInterestedReason.Position),
            new NumberViewModel("The location doesn't work for me", JobWorkerNotInterestedReason.Location),
        ]
    }

    static jobContactNotInterestedReasons(): NumberViewModel[] {
        return [
            new NumberViewModel("Not enough experience", JobContactNotInterestedReason.NotEnoughExperience),
        ]
    }

    static jobWorkerRejectedReasons(): NumberViewModel[] {
        return [
            new NumberViewModel("Not enough experience", JobWorkerRejectedReason.NotEnoughExperience),
        ]
    }

    static jobWorkerOfferCancelledReasons(): NumberViewModel[] {
        return [
            new NumberViewModel("Created by mistake", OfferCancelledReason.CreatedByMistake),
            new NumberViewModel("Contact changed their mind", OfferCancelledReason.ContactChangedMind),
            new NumberViewModel("Contact has a budget issue", OfferCancelledReason.ContactBudgetIssue),
            new NumberViewModel("Contact found alternative worker", OfferCancelledReason.ContactFoundAlternativeWorker),
            new NumberViewModel("Contact no longer requires this position", OfferCancelledReason.ContactPositionNoLongerRequired)
        ]
    }

    static jobWorkerInterviewCancelledReasons(): NumberViewModel[] {
        return [
            new NumberViewModel("Created by mistake", InterviewCancelledReason.CreatedByMistake),
            new NumberViewModel("Contact unavailable", InterviewCancelledReason.ContactUnavailable),
            new NumberViewModel("Contact no longer interested", InterviewCancelledReason.ContactNoLongerInterested),
            new NumberViewModel("Worker unavailable", InterviewCancelledReason.WorkerUnavailable),
            new NumberViewModel("Worker no longer interested", InterviewCancelledReason.WorkerNoLongerInterested)
        ]
    }

    static jobWorkerInterviewWorkerDeclinedReasons(): NumberViewModel[] {
        return [
            new NumberViewModel("Not available at this time", JobWorkerInterviewWorkerDeclinedReason.Unavailable),
            new NumberViewModel("No longer interested", JobWorkerInterviewWorkerDeclinedReason.NoLongerInterested),
        ]
    }

    static jobWorkerInterviewContactDeclinedReasons(): NumberViewModel[] {
        return [
            new NumberViewModel("Not available at this time", JobWorkerInterviewContactDeclinedReason.Unavailable),
            new NumberViewModel("No longer interested", JobWorkerInterviewContactDeclinedReason.NoLongerInterested),
        ]
    }

    static jobWorkerOfferWorkerDeclinedReasons(): NumberViewModel[] {
        return [
            new NumberViewModel("Salary is too low", JobWorkerOfferWorkerDeclinedReason.Salary),
            new NumberViewModel("Found another job", JobWorkerOfferWorkerDeclinedReason.FoundAnotherJob),
            new NumberViewModel("Counter offer made by current employer", JobWorkerOfferWorkerDeclinedReason.CounterOffer),
            new NumberViewModel("No longer looking", JobWorkerOfferWorkerDeclinedReason.NoLongerLooking),
        ]
    }

    static jobWorkerOfferContactDeclinedReasons(): NumberViewModel[] {
        return [
            new NumberViewModel("Changed mind about this worker", JobWorkerOfferContactDeclinedReason.ChangedMind),
            new NumberViewModel("Insufficient budget", JobWorkerOfferContactDeclinedReason.BudgetIssue),
            new NumberViewModel("Found alternative worker", JobWorkerOfferContactDeclinedReason.FoundAlternativeWorker),
            new NumberViewModel("Position no longer required", JobWorkerOfferContactDeclinedReason.PositionNoLongerRequired),
        ]
    }

    static timesheetStatuses(): NumberViewModel[] {
        return [
            new NumberViewModel("Pending", TimesheetStatus.Pending),
            new NumberViewModel("Approved", TimesheetStatus.Approved),
        ]
    }

    static invoiceStatuses(): NumberViewModel[] {
        return [
            new NumberViewModel("Pending", InvoiceStatus.Pending),
            new NumberViewModel("Sent To Accounting", InvoiceStatus.Draft),
            // new NumberViewModel("Submitted", InvoiceStatus.Submitted),
            // new NumberViewModel("Authorised", InvoiceStatus.Authorised),
            // new NumberViewModel("Paid", InvoiceStatus.Paid),
            // new NumberViewModel("Voided", InvoiceStatus.Voided),
            new NumberViewModel("Deleted", InvoiceStatus.Deleted),
        ]
    }

    static invoiceTypes(): NumberViewModel[] {
        return [
            new NumberViewModel("Temp (Timesheets)", 1),
            new NumberViewModel("Perm (Job Placements)", 2),
        ]
    }

    static cancelledReasonsForBooker(): CancelledReasonViewModel[] {
        return [
            new CancelledReasonViewModel("Created by mistake", CancelledReason.CANCELLED_REASON_CREATED_BY_MISTAKE),
            new CancelledReasonViewModel("Requirements changed", CancelledReason.CANCELLED_REASON_REQUIREMENTS_CHANGED),
        ]
    }

    static cancelledReasonsForWorker(): CancelledReasonViewModel[] {
        return [
            new CancelledReasonViewModel("Created by mistake", CancelledReason.CANCELLED_REASON_CREATED_BY_MISTAKE),
            new CancelledReasonViewModel("Requirements changed", CancelledReason.CANCELLED_REASON_REQUIREMENTS_CHANGED),
            new CancelledReasonViewModel("Worker no longer available", CancelledReason.CANCELLED_REASON_WORKER_NO_LONGER_AVAILABLE),
        ]
    }

    static bookingRoleWorkerShiftRejectedReasons(): NumberViewModel[] {
        return [
            new NumberViewModel("Cannot work enough shifts", BookingRoleWorkerShiftRejectedReason.CannotWorkEnoughShifts),
            new NumberViewModel("Customer requirements changed", BookingRoleWorkerShiftRejectedReason.CustomerRequirementsChanged),
            new NumberViewModel("Shifts already filled", BookingRoleWorkerShiftRejectedReason.ShiftsAlreadyFilled),
            new NumberViewModel("Insufficient skills/qualifications/experience", BookingRoleWorkerShiftRejectedReason.SkillQualificationExperienceGap),
        ]
    }

    static breaks(): NumberViewModel[] {
        return [
            new NumberViewModel("None", 0),
            new NumberViewModel("5 mins", 5),
            new NumberViewModel("10 mins", 10),
            new NumberViewModel("15 mins", 15),
            new NumberViewModel("20 mins", 20),
            new NumberViewModel("25 mins", 25),
            new NumberViewModel("30 mins", 30),
            new NumberViewModel("35 mins", 35),
            new NumberViewModel("40 mins", 40),
            new NumberViewModel("45 mins", 45),
            new NumberViewModel("50 mins", 50),
            new NumberViewModel("55 mins", 55),
            new NumberViewModel("1 hour", 60),
            new NumberViewModel("1 hour 5 mins", 65),
            new NumberViewModel("1 hour 10 mins", 70),
            new NumberViewModel("1 hour 15 mins", 75),
            new NumberViewModel("1 hour 20 mins", 80),
            new NumberViewModel("1 hour 25 mins", 85),
            new NumberViewModel("1 hour 30 mins", 90),
            new NumberViewModel("1 hour 35 mins", 95),
            new NumberViewModel("1 hour 40 mins", 100),
            new NumberViewModel("1 hour 45 mins", 105),
            new NumberViewModel("1 hour 50 mins", 110),
            new NumberViewModel("1 hour 55 mins", 115),
            new NumberViewModel("2 hours", 120),
        ]
    }

    static travelTimes(): NumberViewModel[] {
        return [
            new NumberViewModel("0", 0),
            new NumberViewModel("5", 5),
            new NumberViewModel("10", 10),
            new NumberViewModel("15", 15),
            new NumberViewModel("20", 20),
            new NumberViewModel("25", 25),
            new NumberViewModel("30", 30),
            new NumberViewModel("35", 35),
            new NumberViewModel("40", 40),
            new NumberViewModel("45", 45),
            new NumberViewModel("50", 50),
            new NumberViewModel("55", 55),
            new NumberViewModel("60", 60),
            new NumberViewModel("65", 65),
            new NumberViewModel("70", 70),
            new NumberViewModel("75", 75),
            new NumberViewModel("80", 80),
            new NumberViewModel("85", 85),
            new NumberViewModel("90", 90),
            new NumberViewModel("95", 95),
            new NumberViewModel("100", 100),
            new NumberViewModel("105", 105),
            new NumberViewModel("110", 110),
            new NumberViewModel("115", 115),
            new NumberViewModel("120", 120),
        ]
    }

    static availabilityTypes() {
        const availabilityOptions: AvailabilityViewModel[] = [];
        availabilityOptions.push(new AvailabilityViewModel(Availability.MonAM, "Monday AM"));
        availabilityOptions.push(new AvailabilityViewModel(Availability.MonPM, "Monday PM"));
        availabilityOptions.push(new AvailabilityViewModel(Availability.TueAM, "Tuesday AM"));
        availabilityOptions.push(new AvailabilityViewModel(Availability.TuePM, "Tuesday PM"));
        availabilityOptions.push(new AvailabilityViewModel(Availability.WedAM, "Wednesday AM"));
        availabilityOptions.push(new AvailabilityViewModel(Availability.WedPM, "Wednesday PM"));
        availabilityOptions.push(new AvailabilityViewModel(Availability.ThuAM, "Thursday AM"));
        availabilityOptions.push(new AvailabilityViewModel(Availability.ThuPM, "Thursday PM"));
        availabilityOptions.push(new AvailabilityViewModel(Availability.FriAM, "Friday AM"));
        availabilityOptions.push(new AvailabilityViewModel(Availability.FriPM, "Friday PM"));
        availabilityOptions.push(new AvailabilityViewModel(Availability.SatAM, "Saturday AM"));
        availabilityOptions.push(new AvailabilityViewModel(Availability.SatPM, "Saturday PM"));
        availabilityOptions.push(new AvailabilityViewModel(Availability.SunAM, "Sunday AM"));
        availabilityOptions.push(new AvailabilityViewModel(Availability.SunPM, "Sunday PM"));
        return availabilityOptions;
    }


    static vehicleAccessTypes(includeNone: boolean): VehicleAccessTypeViewModel[] {
        const vms: VehicleAccessTypeViewModel[] = [];
        if (includeNone) {
            vms.push(new VehicleAccessTypeViewModel("None", VehicleAccessType.None));
        }
        vms.push(new VehicleAccessTypeViewModel("Bicycle", VehicleAccessType.Bicycle));
        vms.push(new VehicleAccessTypeViewModel("Motorcycle - Provisional License", VehicleAccessType.MotorcycleProvisionalLicense));
        vms.push(new VehicleAccessTypeViewModel("Motorcycle - Full License", VehicleAccessType.MotorcycleFullLicense));
        vms.push(new VehicleAccessTypeViewModel("Car - 2 Seats", VehicleAccessType.Car2Seats));
        vms.push(new VehicleAccessTypeViewModel("Car - 3 Seats", VehicleAccessType.Car3Seats));
        vms.push(new VehicleAccessTypeViewModel("Car - 4 Seats", VehicleAccessType.Car4Seats));
        vms.push(new VehicleAccessTypeViewModel("Car - 5 Seats", VehicleAccessType.Car5Seats));
        vms.push(new VehicleAccessTypeViewModel("Car - 6 Seats", VehicleAccessType.Car6Seats));
        vms.push(new VehicleAccessTypeViewModel("Car - 7 Seats", VehicleAccessType.Car7Seats));
        return vms;
    }

    static passengerOptions(): NumberViewModel[] {
        return [
            new NumberViewModel("0",0),
            new NumberViewModel("1",1),
            new NumberViewModel("2",2),
            new NumberViewModel("3",3),
            new NumberViewModel("4",4),
            new NumberViewModel("5",5),
            new NumberViewModel("6",6),
            new NumberViewModel("7",7),
            new NumberViewModel("8",8),
            new NumberViewModel("9",9),
            new NumberViewModel("10",10),
        ]
    }

    static journeyTypeOptions(): NumberViewModel[] {
        return [
            new NumberViewModel("Own Way There",JourneyType.OwnWayThere),
            new NumberViewModel("Passenger To Location",JourneyType.PassengerToLocation),
            new NumberViewModel("Passenger From Location",JourneyType.PassengerFromLocation),
            new NumberViewModel("Passenger Round Trip",JourneyType.PassengerRoundTrip),
            new NumberViewModel("Driver To Location",JourneyType.DriverToLocation),
            new NumberViewModel("Driver From Location",JourneyType.DriverFromLocation),           
            new NumberViewModel("Driver Round Trip",JourneyType.DriverRoundTrip),           
        ]
    }

    static journeyCalculationTypeOptions(): NumberViewModel[] {
        return [
            new NumberViewModel("Manual",JourneyCalculationType.Manual),   
            new NumberViewModel("Template",JourneyCalculationType.Template),     
        ]
    }

    static workTypes(): WorkType[] {
        return [WorkType.Temp, WorkType.Perm]
    }

    static jobTypes(): JobType[] {
        return [JobType.Permanent]
    }

    static jobWorkerInterviewTypeOptions(): NumberViewModel[] {
        return [
            new NumberViewModel("Telephone", JobWorkerInterviewType.Telephone),
            new NumberViewModel("Online", JobWorkerInterviewType.Online),
            new NumberViewModel("In Person", JobWorkerInterviewType.InPerson),
        ]
    }

    static inPersonInterviewAddressTypeOptions(): NumberViewModel[] {
        return [
            //new NumberViewModel("Company Address", InPersonInterviewAddressType.CompanyAddress),
           // new NumberViewModel("Job Interview Address", InPersonInterviewAddressType.JobInterviewAddress),
            new NumberViewModel("Job Location", InPersonInterviewAddressType.JobLocation),
            new NumberViewModel("Other Location", InPersonInterviewAddressType.OtherLocation),
            new NumberViewModel("Other Address", InPersonInterviewAddressType.OtherAddress),
        ]
    }

    static calendarTypes(): StringViewModel[] {
        return [
            new StringViewModel("Day", CalendarTypes.Day),
            new StringViewModel("4 Day", CalendarTypes.FourDay),
            new StringViewModel("Week", CalendarTypes.Week),
            new StringViewModel("Month", CalendarTypes.Month)
        ]
    }

    static integrationSystems(): StringViewModel[] {
        return [
            new StringViewModel("SendGrid", IntegrationSystemIdConstants.SendGrid),
            new StringViewModel("Xero", IntegrationSystemIdConstants.Xero),
            new StringViewModel("Microsoft 365", IntegrationSystemIdConstants.Microsoft365),
            new StringViewModel("Google Workspace", IntegrationSystemIdConstants.GoogleWorkspace),
            new StringViewModel("PurePro", IntegrationSystemIdConstants.PurePro),
        ]
    }

    // static consolidatedSkills(positions: PositionDto[]) {
    //     const skills = skills[]
    // }

    static countries() {
        const list = countries.getNames('en', { select: 'official' })
        return Object.keys(list).map((key) => ({ value: key, name: list[key] }))
    }

    static nationalities() {
        return [
            "Afghan",
            "Albanian",
            "Algerian",
            "American",
            "Andorran",
            "Angolan",
            "Antiguans",
            "Argentinean",
            "Armenian",
            "Australian",
            "Austrian",
            "Azerbaijani",
            "Bahamian",
            "Bahraini",
            "Bangladeshi",
            "Barbadian",
            "Barbudans",
            "Batswana",
            "Belarusian",
            "Belgian",
            "Belizean",
            "Beninese",
            "Bhutanese",
            "Bolivian",
            "Bosnian",
            "Brazilian",
            "British",
            "Bruneian",
            "Bulgarian",
            "Burkinabe",
            "Burmese",
            "Burundian",
            "Cambodian",
            "Cameroonian",
            "Canadian",
            "Cape Verdean",
            "Central African",
            "Chadian",
            "Chilean",
            "Chinese",
            "Colombian",
            "Comoran",
            "Congolese",
            "Costa Rican",
            "Croatian",
            "Cuban",
            "Cypriot",
            "Czech",
            "Danish",
            "Djibouti",
            "Dominican",
            "Dutch",
            "East Timorese",
            "Ecuadorean",
            "Egyptian",
            "Emirian",
            "Equatorial Guinean",
            "Eritrean",
            "Estonian",
            "Ethiopian",
            "Fijian",
            "Filipino",
            "Finnish",
            "French",
            "Gabonese",
            "Gambian",
            "Georgian",
            "German",
            "Ghanaian",
            "Greek",
            "Grenadian",
            "Guatemalan",
            "Guinea-Bissauan",
            "Guinean",
            "Guyanese",
            "Haitian",
            "Herzegovinian",
            "Honduran",
            "Hungarian",
            "I-Kiribati",
            "Icelander",
            "Indian",
            "Indonesian",
            "Iranian",
            "Iraqi",
            "Irish",
            "Israeli",
            "Italian",
            "Ivorian",
            "Jamaican",
            "Japanese",
            "Jordanian",
            "Kazakhstani",
            "Kenyan",
            "Kittian and Nevisian",
            "Kuwaiti",
            "Kyrgyz",
            "Laotian",
            "Latvian",
            "Lebanese",
            "Liberian",
            "Libyan",
            "Liechtensteiner",
            "Lithuanian",
            "Luxembourger",
            "Macedonian",
            "Malagasy",
            "Malawian",
            "Malaysian",
            "Maldivan",
            "Malian",
            "Maltese",
            "Marshallese",
            "Mauritanian",
            "Mauritian",
            "Mexican",
            "Micronesian",
            "Moldovan",
            "Monacan",
            "Mongolian",
            "Moroccan",
            "Mosotho",
            "Motswana",
            "Mozambican",
            "Namibian",
            "Nauruan",
            "Nepalese",
            "New Zealander",
            "Nicaraguan",
            "Nigerian",
            "Nigerien",
            "North Korean",
            "Northern Irish",
            "Norwegian",
            "Omani",
            "Pakistani",
            "Palauan",
            "Palestinian",
            "Panamanian",
            "Papua New Guinean",
            "Paraguayan",
            "Peruvian",
            "Polish",
            "Portuguese",
            "Qatari",
            "Romanian",
            "Russian",
            "Rwandan",
            "Saint Lucian",
            "Salvadoran",
            "Samoan",
            "San Marinese",
            "Sao Tomean",
            "Saudi",
            "Scottish",
            "Senegalese",
            "Serbian",
            "Seychellois",
            "Sierra Leonean",
            "Singaporean",
            "Slovakian",
            "Slovenian",
            "Solomon Islander",
            "Somali",
            "South African",
            "South Korean",
            "Spanish",
            "Sri Lankan",
            "Sudanese",
            "Surinamer",
            "Swazi",
            "Swedish",
            "Swiss",
            "Syrian",
            "Taiwanese",
            "Tajik",
            "Tanzanian",
            "Thai",
            "Togolese",
            "Tongan",
            "Trinidadian or Tobagonian",
            "Tunisian",
            "Turkish",
            "Tuvaluan",
            "Ugandan",
            "Ukrainian",
            "Uruguayan",
            "Uzbekistani",
            "Venezuelan",
            "Vietnamese",
            "Welsh",
            "Yemenite",
            "Zambian",
            "Zimbabwean"
         ]
    }
}